import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export const PAYS_LIST = [
    'France', 'Belgique', 'Suisse', 'Luxembourg', 'Canada', 'Monaco',
    'Allemagne', 'Espagne', 'Italie', 'Portugal', 'Pays-Bas', 'Royaume-Uni',
    'États-Unis', 'Maroc', 'Tunisie', 'Algérie', 'Sénégal', 'Côte d\'Ivoire',
    'Madagascar', 'Réunion', 'Martinique', 'Guadeloupe', 'Guyane',
    'Autre',
];

export default function PaysSelect({ value, onChange, label = 'Pays', fullWidth = true, size }) {
    return (
        <FormControl fullWidth={fullWidth} size={size}>
            <InputLabel>{label}</InputLabel>
            <Select value={value || ''} onChange={onChange} label={label}>
                {PAYS_LIST.map(p => (
                    <MenuItem key={p} value={p}>{p}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
